import { z } from 'zod';

export const systemSettingHttp$ = z.object({
  name: z.string(),
  setting: z.string(),
  settings_type: z.string(),
  value: z.unknown().default(undefined),
  enterprise_workspace_id: z.number().int().nullable(),
  enterprise_team_id: z.number().int().nullable()
});

export const systemSettingsListHttp$ = z.array(systemSettingHttp$);
